// @flow strict

import { logger } from '../../util/logger'

/**
 * Error action creator
 * @param  {Error} error - Error
 * @return {object}       [description]
 */
const doError = error => {
  logger.error(new Error('REDUX'), { error })
  return { type: 'ERROR', payload: error, error: true }
}

/**
 * Error reporting redux middleware
 * @see {https://bionic.fullstory.com/react-redux-errors-with-fullstory-and-sentry/#3catchingunhandlederrorsinreduxactioncreatorsandreducers}
 * @param  {Object} store - Redux store
 * @return {Function} - `next` function
 */
export const errorReporter = (store: Object) => (next: Function) => (
  action: Object
) => {
  // we got a thunk, prep it to be handled by redux-thunk middleware
  if (typeof action === 'function') {
    // wrap it in a function to try/catch the downstream invocation
    const wrapAction = fn => (dispatch, getState, extraArgument) => {
      try {
        fn(dispatch, getState, extraArgument)
      } catch (e) {
        dispatch(doError(e))
      }
    }
    // send wrapped function to the next middleware
    // this should be upstrem from redux-thunk middleware
    return next(wrapAction(action))
  }

  try {
    return next(action)
  } catch (e) {
    store.dispatch(doError(e))
  }
}

export default errorReporter
